import React, { useEffect, useRef, useState } from "react";

const terms = [
  "KeCheng.",
  "a back-end developer.",
  "a front-end developer.",
  "a full-stack developer.",
];

const wait = (duration) => new Promise((resolve) => setTimeout(resolve, duration));

export function TypedIdentity() {
  const rootRef = useRef(null);
  const [started, setStarted] = useState(false);
  const [text, setText] = useState(terms[0]);
  const [isStatic, setIsStatic] = useState(false);

  useEffect(() => {
    const isTest = navigator.userAgent.toLowerCase().includes("jsdom");
    const reduceMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

    if (isTest || reduceMotion || !("IntersectionObserver" in window)) {
      setText(terms[0]);
      setIsStatic(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStarted(true);
          observer.disconnect();
        }
      },
      { threshold: 0.65 }
    );

    observer.observe(rootRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!started) return undefined;
    let cancelled = false;

    const typeSequence = async () => {
      let current = terms[0];
      let nextIndex = 1;

      while (!cancelled) {
        const next = terms[nextIndex];
        await wait(1100);
        while (current.length && !cancelled) {
          current = current.slice(0, -1);
          setText(current);
          await wait(32);
        }

        for (const character of next) {
          if (cancelled) return;
          current += character;
          setText(current);
          await wait(48);
        }

        nextIndex = (nextIndex + 1) % terms.length;
      }
    };

    typeSequence();
    return () => {
      cancelled = true;
    };
  }, [started]);

  return (
    <h2 className={`typed-identity ${isStatic ? "is-static" : ""}`} ref={rootRef} aria-label="Hi, I am KeCheng.">
      <span>Hi, I am </span>
      <span aria-hidden="true">{text}</span>
      <span className="typed-identity__caret" aria-hidden="true" />
    </h2>
  );
}
